<template>
  <main>
    <DetailAwards />
  </main>
</template>

<script>
import { constantsComputed } from '@/store/helpers'
import { getBaseURL, getBaseMetaCurrentYear } from '@/environments'

const DetailAwards = () => import('@/components/Awards/Categories/Detail')

export default {
  components: {
    DetailAwards
  },

  computed: {
    ...constantsComputed
  },

  metaInfo: {
    meta: [
      { name: 'publisher', content: 'admanawards.com/' },
      { name: 'og:url', content: getBaseURL() },
      { name: 'og:title', content: `Adman Awards & Symposium ${getBaseMetaCurrentYear}` },
      { name: 'og:description', content: 'Be the First Winner of the Most Honorable Award' },
      { name: 'og:image', content: `${getBaseURL()}/img/og_adman.jpg` },
      { name: 'og:site_name', content: 'AdmanAwards' },
      { name: 'og:type', content: 'website' }
      // you can also add open graph tags here
    ]
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
</style>
